module.exports = __webpack_public_path__ + "static/media/ProlitigioLogo_1.4689de9e.svg";